import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import Cookies from 'js-cookie';
import backgroundImage from '../../assets/images/test.jpg';
interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    const transformAndSetCookie = () => {
      const rawCaseStudy: string | undefined = keycloak.idTokenParsed?.case_study;
      let transformedValue: string | null = null;

      if (rawCaseStudy) {
        const lowerCaseRaw = rawCaseStudy.toLowerCase();

        switch (lowerCaseRaw) {
          case 'cyprus':
            transformedValue = 'cyprus';
            break;
          case 'greece':
            transformedValue = 'greece';
            break;
          case 'spain':
            transformedValue = 'barcelona';
            break;
          case 'france':
            transformedValue = 'pnr_narbonnaise';
            break;
          default:
            transformedValue = lowerCaseRaw;
        }
      }

      if (transformedValue) {
        Cookies.set('caseStudy', transformedValue, { expires: 7 });
      } else {
        Cookies.remove('caseStudy');
      }
    };

    transformAndSetCookie();
  }, [keycloak.authenticated, keycloak.idTokenParsed, keycloak.token]);

  if (!initialized) {
    return (
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            padding: '2rem 3rem',
            borderRadius: '12px',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          Loading authentication...
        </div>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
